import { motion } from "framer-motion";
import { PhoneCall, Rotate3d, TrendingUp, CalendarCheck, BadgePercent, Headphones } from "lucide-react";
import { openEnquiry } from "../lib/modal";

const PILLS = [
  { icon: PhoneCall, label: "Instant Call Back", intent: "Request Call Back" },
  { icon: Rotate3d, label: "360° Virtual Tour", intent: "Schedule Site Visit" },
  { icon: TrendingUp, label: "High ROI Deals", intent: "Pre-Launch EOI" },
  { icon: CalendarCheck, label: "Free Site Visit", intent: "Schedule Site Visit" },
  { icon: BadgePercent, label: "Best Price", intent: "Pre-Launch EOI" },
  { icon: Headphones, label: "24×7 Support Desk", intent: "Request Call Back" },
];

export default function FeaturePills() {
  return (
    <div data-testid="feature-pills" className="border-b border-border bg-background">
      <div className="max-w-screen-2xl mx-auto px-6 py-8 flex gap-4 overflow-x-auto md:justify-center">
        {PILLS.map(({ icon: Icon, label, intent }, i) => (
          <motion.button
            key={label}
            onClick={() => openEnquiry(intent)}
            data-testid={`pill-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06, duration: 0.5 }}
            className="flex items-center gap-3 border border-border px-5 py-3 whitespace-nowrap hover:border-primary hover:bg-primary/5 hover:-translate-y-0.5 transition-[border-color,background-color,transform] duration-300"
          >
            <Icon size={16} className="text-primary" strokeWidth={1.5} />
            <span className="text-[10px] uppercase tracking-[0.25em] text-foreground/80">{label}</span>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
